<template>
  <div
    class="sm-dynamic-table-item"
    :class="{ 
      open: isOpen && allowExpand && !isFooter && !isActiveCustomersRow,
      footer: isFooter,
      'sub-header': isActiveCustomersRow
    }"
  >
    <div class="sm-dynamic-table-item-row" @click="toggleItem">
      <div
        class="sm-dynamic-table-item-row-elem sticky-col"
        
      >
        <include-svg
          v-show="!isFooter && !isActiveCustomersRow && allowExpand"
          :name="'icon-arrow-b-big'"
        />
      </div>

      <div
        class="sm-dynamic-table-item-row-elem sm-txt-strong sticky-col"
        :style="{width: titleWidth + 'px'}"
      >
        <text-truncate
          :text="curItem.title"
          :classes="`${isFooter ? 'uppercase sm-text-strong' : 'sm-txt-strong'} ${isActiveCustomersRow ? 'small-hint' : 'sm-txt-strong'}`"
        />
      </div>

      <div
        v-for="head in heads"
        :key="head"
        :class="{ hide: isOpen && !isFooter, 'sm-txt-strong': isFooter }"
        class="sm-dynamic-table-item-row-elem sum sm-txt-center show"
      >
        {{ priceFormat ? formatPrice(item[head]) : item[head] }}
      </div>
      <div
        :class="{ hide: isOpen && !isFooter, 'sm-txt-strong': isFooter }"
        class="sm-dynamic-table-item-row-elem sm-txt-right sm-txt-strong show"
      >
        {{ priceFormat ? formatPrice(item.total) : item.total }}
      </div>
    </div>
    <ul class="sm-dynamic-table-item-dropdown">
      <li>
        <div
          v-for="(customer, index) in item.details"
          :key="index"
          class="sm-dynamic-table-item-row dropdown"
        >
          <div
            class="sm-dynamic-table-item-row-elem sticky-col"
          ></div>
          <div
            class="sm-dynamic-table-item-row-elem indent-2 sticky-col"
            :style="{width: titleWidth + 'px'}"

          >
            <text-truncate :text="customer.title" :classes="'small-hint'" />
          </div>
          <div
            v-for="head in heads"
            :key="head"
            class="sm-dynamic-table-item-row-elem sm-txt-center"
          >
            {{ priceFormat ? formatPrice(customer[head]) : customer[head] }}
          </div>
          <div
            class="sm-dynamic-table-item-row-elem sm-txt-right sm-txt-strong"
          >
            {{ priceFormat ? formatPrice(customer.total) : customer.total }}
          </div>
        </div>
      </li>
      <li>
        <div class="sm-dynamic-table-item-row sum" @click="toggleItem">
          <div
            
            class="sm-dynamic-table-item-row-elem control-arrow sticky-col"
          ></div>

          <div
            :style="{width: titleWidth + 'px'}"
            
            class="sm-dynamic-table-item-row-elem sticky-col"
          >
            <text-truncate :text="curItem.title" :classes="'uppercase small-hint'" />
          </div>

          <div
            v-for="head in heads"
            :key="head"
            class="
              sm-dynamic-table-item-row-elem
              sum
              sm-txt-center sm-txt-strong
            "
          >
            {{ priceFormat ? formatPrice(item[head]) : item[head] }}
          </div>
          <div
            class="sm-dynamic-table-item-row-elem sm-txt-right sm-txt-strong"
          >
            {{ priceFormat ? formatPrice(item.total) : item.total }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { FormatPrice } from "@/utils/general-data";
import TextTruncate from "@/components/TextTruncate.vue";

export default {
  name: "org-admin-reports-item",
  components: { TextTruncate },
  props: {
    heads: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    viewPort: {
      type: String,
      default: "large",
    },
    allRowsExpanded: {
      type: Boolean,
      default: false,
    },
    allowExpand: {
      type: Boolean,
      default: true,
    },
    priceFormat: {
      type: Boolean,
      default: true,
    },
    titleWidth: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      curItem: {},
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
    }),
    isFooter() {
      return this.curItem.title === "Total Summary";
    },
    isActiveCustomersRow() {
      return this.curItem.title === "Current number of active customers"
    }
  },
  created() {
    this.prepareItem({ ...this.item });
  },
  methods: {
    ...mapActions({
      getOrgReportDetails: "reports/getOrgReportDetails",
    }),
    formatPrice: FormatPrice,
    prepareItem(item) {
      this.curItem = { ...item };
    },
    toggleItem() {
      if (!this.allowExpand || this.isActiveCustomersRow) return;
      this.isOpen = !this.isOpen;
    },
  },
  watch: {
    item(val) {
      this.prepareItem(val);
      this.isOpen = false;
    },
    allRowsExpanded(val) {
      if (!this.allowExpand || this.isActiveCustomersRow) return;
      this.isOpen = val;
    },
  },
};
</script>